import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('blog-posts', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`blog-posts/${id}`).then(result => result.data)
  },
  update(blogPostId, data) {
    return axios.patch(`blog-posts/${blogPostId}`, data).then(result => result.data)
  },
  store(data) {
    return axios.post('blog-posts', data).then(result => result.data)
  },
  delete(id) {
    return axios.delete(`blog-posts/${id}`).then(result => result.data)
  }
}
